class Accordeon {
  constructor() {
    this.addOpenClick()
  }

  addOpenClick() {
    var accordeon = document.getElementsByClassName("el-accordeon__row__title");
    var i;
    for (i = 0; i < accordeon.length; i++) {
      accordeon[i].addEventListener("click", function () {
        $(this)[0].classList.toggle("accordeon-open");
        $(this).parent()[0].classList.toggle("accordeon-open");
      });
    }
  }
}
